import { isOver } from "../../js/lib/util";

const breakpoint = 1023;
const featuredImageShiftScale = 0.16;

export default (el) => {
  const parallaxImage = el.dataset.parallaxImage === "true";
  const featuredImages = Array.from(el.querySelectorAll(".js-hero-img"));
  const rollngText = el.querySelector(".js-rolling-text") as HTMLElement;

  if (!featuredImages.length) {
    return;
  }

  const shift = (targets, scale) => {
    if (!isOver(breakpoint)) {
      return;
    }

    const y = el.getBoundingClientRect().y;

    if (y > window.innerHeight || y < -400) {
      return;
    }
    for (let target of targets) {
      target.style.transform = `translateY(calc(${-y}px * ${-scale}))`;
    }
  };

  const addStyleBottom = () => {
    for (let featuredImage of featuredImages) {
      if (isOver(breakpoint)) {
        featuredImage.style.bottom = "-85px";
      } else {
        featuredImage.style.bottom = "";
        featuredImage.style.transform = "";
      }
    }
  };

  if (parallaxImage) {
    if ("IntersectionObserver" in window) {
      addStyleBottom();
      window.addEventListener("resize", addStyleBottom);

      let observerOptions = {
        root: null,
        rootMargin: "0px",
      };

      let intersectionCallback = (entries) => {
        if (entries[0].isIntersecting) {
          window.addEventListener("scroll", () => {
            shift(featuredImages, featuredImageShiftScale);
          });
        }
      };

      let observer = new window.IntersectionObserver(
        intersectionCallback,
        observerOptions
      );
      observer.observe(el);
    }
  }

  window.addEventListener("scroll", () => {
    if (rollngText) {
      const viewportOffset = el.getBoundingClientRect().top;
      const moduleOffset = (viewportOffset / el.clientHeight) * 100;
      const scrollPercent = 100 - moduleOffset;
      const step = Math.round(scrollPercent / 25);

      if (step >= 0 && step < 5) {
        rollngText.style.transform = `translateY(-${step + 0.1}em`;
      }
    }
  });
};
